// extracted by mini-css-extract-plugin
export default {"wrapper":"PcvNkdUQucVaec877xnd","placeholder":"ALILjyxn2G2k7bbgtxJU"};